import { findPartyPackage, PACKAGE_PRICING_VERSION } from "../constants/packageDefaults";
import { roundCurrency, toFiniteNumber } from "./bookingCalculations";

export const guestCount = (value) => Math.max(0, Math.floor(toFiniteNumber(value)));

export const calculateGuestCharges = (pkg, kids, adults) => {
  // Unspecified weekday allowances must not turn all attendees into extras.
  // Those packages retain manual extra-guest entry in the invoice generator.
  const additionalKids = pkg?.includedKids == null ? 0
    : Math.max(0, guestCount(kids) - guestCount(pkg.includedKids));
  const additionalAdults = pkg?.includedAdults == null ? 0
    : Math.max(0, guestCount(adults) - guestCount(pkg.includedAdults));
  return {
    additionalKids,
    additionalAdults,
    total: roundCurrency(
      additionalKids * toFiniteNumber(pkg?.additionalChildPrice) +
      additionalAdults * toFiniteNumber(pkg?.additionalAdultPrice)
    ),
  };
};

export const createPricingSnapshot = (packageType) => {
  const pkg = findPartyPackage(packageType);
  return pkg ? { version: PACKAGE_PRICING_VERSION, package: { ...pkg } } : null;
};

// Exclude pricing from unrelated updates. updateDoc merges this payload, keeping
// all previously agreed prices, payments and financial fields exactly as stored.
export const bookingPricingUpdate = (existingBooking, packageType, adoptCurrentPricing = false) => {
  if (existingBooking && existingBooking.packageType === packageType && !adoptCurrentPricing) return {};
  return { pricingSnapshot: createPricingSnapshot(packageType) };
};

export const packageEndTime = (startTime, durationHours) => {
  if (!durationHours || !/^\d{2}:\d{2}$/.test(startTime || "")) return null;
  const [hours, minutes] = startTime.split(":").map(Number);
  const end = hours * 60 + minutes + durationHours * 60;
  // The calendar stores a same-day end time. Let staff set overnight times.
  if (end >= 24 * 60) return null;
  return `${String(Math.floor(end / 60)).padStart(2, "0")}:${String(end % 60).padStart(2, "0")}`;
};

export const applyPackageToNewBooking = (form, packageType) => {
  const pricingSnapshot = createPricingSnapshot(packageType);
  const pkg = pricingSnapshot?.package;
  return {
    ...form,
    packageType,
    pricingSnapshot,
    ...(pkg?.includedKids != null ? { numberOfKids: pkg.includedKids } : {}),
    ...(pkg?.includedAdults != null ? { numberOfGuests: pkg.includedAdults } : {}),
    endTime: packageEndTime(form.startTime, pkg?.durationHours) || form.endTime,
  };
};
